export default class UserActivitySerializer {
  static serialize(data) {
    return {
      activityId: data.activityId,
      userId: data.userId,
      componentName: data.componentName,
      action: data.action,
      timeStamp: data.timeStamp
    };
  }

  static deSerialize(data) {
    return {
      activityId: data.activityId,
      userId: data.userId,
      componentName: data.componentName,
      action: data.action,
      timeStamp: data.timeStamp,
      timeStampTime: data.timeStamp + "Z"
    };
  }
}